<template>
    <div>
        <gallery-form-group
                v-model="data.image_id"
                name="image_id"
                label="Image"
                :error="(errors.image_id || [])[0]"
        />
    </div>
</template>

<script>
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'

    export default {
        components: {GalleryFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },
        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
